"use strict";

angular.module("customer")
.controller("GoodsTransferDetailsController", function(
    $scope, $state, $stateParams, $timeout, gettextCatalog, GoodsTransferService, PreventUnsavedChangesService,
    StocksService, PatternService, ProductDetailsModalService, StateExtensionService, FlashBag, FormError, common
) {
    var _this = this;
    const DEFAULT_AVAILABLE_PRODUCTS_QUANTITY = 1;

    $scope.search = {};
    $scope.disableSubmitButton = false;
    $scope.hasUnsavedChanges = false;
    $scope.pattern = PatternService;
    $scope.isReadOnly = !!$stateParams.id;
    $scope.availableCatalogs = [];
    $scope.goodsTransfer = {};
    $scope.params = angular.extend({}, $stateParams);

    $scope.$watch("goodsTransferForm.$dirty", function(newValue) {
        $scope.hasUnsavedChanges = newValue;
    });

    $scope.$on("doLiveSearch", function($event, searchTerm) {
        $scope.search = {$: searchTerm};
        $timeout(function() {
            if (searchTerm) {
                common.scrollTo(".value-select:first-of-type");
                if (angular.element(".items-listing").length === 1) {
                    angular.element(".value-select").first().focus().select();
                }
            }
        });
    });

    this.clearSearch = function() {
        $scope.$emit("clearSearch");
    };

    this.showProductDetails = function(product) {
        var productId = product.product_source_id || product.product_destination_id;
        ProductDetailsModalService.showSalesRepProductDetails(productId);
    };

    this.create = function() {
        $scope.goodsTransferForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.goodsTransferForm.$valid) {
            FormError.focus("goodsTransferForm");
            return;
        }

        $scope.disableSubmitButton = true;

        GoodsTransferService.create($scope.goodsTransfer)
        .then(function onSuccess(data) {
            var productErrors = data.product_errors;
            if (data.id) {
                FlashBag.success(gettextCatalog.getString("You successfully created the Goods Transfer."), true);
            }
            if (productErrors) {
                showGoodsTransferErrors(
                    productErrors,
                    gettextCatalog.getString("Some products was ignored when creating the goods transfer:")
                );
            }

            $scope.hasUnsavedChanges = false;
            if (data.id) {
                $timeout(function() {
                    $state.transitionTo($state.$current.name, {"id": data.id}, {location: "replace"});
                });
            }
        }, function onError(response) {
            FlashBag.apiError(response);
        }).finally(function() {
            $scope.disableSubmitButton = false;
        });
    };

    this.getAvailableProducts = function(sourceId) {
        GoodsTransferService.getAvailableProducts(sourceId, $scope.params)
        .then(function onSuccess(response) {
            $scope.hasUnsavedChanges = false;
            if (!response.data) {
                return;
            }
            $scope.goodsTransfer.products = response.data;
        });
    }

    function getGoodsTransfer() {
        GoodsTransferService.get($stateParams.id).$promise
        .then(function onSuccess(data) {
            $scope.goodsTransfer = data;
        });
    }

    function getAvailableCatalogs() {
        GoodsTransferService.getAvailableCatalogs()
        .then(function onSuccess(response) {
            if (!response.data) {
                return;
            }
            $scope.availableCatalogs = response.data;
        });
    }

    function showGoodsTransferErrors(productErrors, errorMessage) {
        if (productErrors && productErrors.length) {
            var message = "<strong>" + errorMessage + "</strong>";
            message += FlashBag.formatErrorList(productErrors);
            FlashBag.warning(message, true, null);
        }
    }

    function refreshAvailableProducts(filters) {
        StateExtensionService.updateUrlParams(filters);
        angular.extend($scope.params, filters);
        _this.getAvailableProducts($scope.goodsTransfer.sourceId);
    }

    if ($stateParams.id) {
        getGoodsTransfer();
    }
    else {
        getAvailableCatalogs();

        if ($scope.params.inventory_quantity_min === undefined) {
            $scope.params.inventory_quantity_min = DEFAULT_AVAILABLE_PRODUCTS_QUANTITY;
            StateExtensionService.updateUrlParams($scope.params);
        }

        $scope.$on("listingFilterUpdated", function(event, filters) {
            if ($scope.hasUnsavedChanges) {
                var unsavedMessage = gettextCatalog.getString("You have unsaved changes on your goods transfer, do you really want to filter?");
                PreventUnsavedChangesService.openModal(unsavedMessage)
                .then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(confirm) {
                        modal.element.remove();
                        if (confirm) {
                            refreshAvailableProducts(filters);
                        }
                    });
                });
            } else {
                refreshAvailableProducts(filters);
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/goods-transfer/goods-transfer-details.controller.js
// module id = 957
// module chunks = 0